import type { PointOfInterestImage } from '../../../Home.type'

interface GetPointOfInterestProps {
	readonly image: PointOfInterestImage
	readonly percentage?: number
}

interface PointOfInterest {
	x: number
	y: number
}

const defaultPercentage = 0.01

export function getPointOfInterest({
	image,
	percentage = defaultPercentage,
}: GetPointOfInterestProps): PointOfInterest {
	return {
		x: image.width * image.pointOfInterest.percentageX * percentage,
		y: image.height * image.pointOfInterest.percentageY * percentage,
	}
}
